module.exports = __webpack_public_path__ + "assets/d918b947-5fcb-42e2-8286-a98a801876de.fd0cbda4.svg";